import { BaseLocator } from "./base.locator";
import { YearLocatorComponent } from "./year.locator-component";
import { CategoryIdLocatorComponent } from "./categoryid.locator-component";
import { CategoryLocatorComponent } from "./category.locator-component";
import { StringLocatorComponent } from "./string.locator-component";
import { DetailedLocatorComponent } from "./detailed.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";

export class SeriesTeamsRankingsLocator extends BaseLocator {
  public catid: CategoryIdLocatorComponent;
  public category: CategoryLocatorComponent;
  public year: YearLocatorComponent;
  public search: StringLocatorComponent;
  public sortindoor: RankSortingLocatorComponent;
  public detailed: DetailedLocatorComponent;
  constructor() {
    super("seriesTeamsRankings");
    this.addComponentByType("catid");
    this.addComponentByType("category");
    this.addComponentByType("year");
    this.addComponentByType("search");
    this.addComponentByType("sortindoor");
    this.addComponentByType("detailed");
    this.addComponentByType("search");
  }
}
